import { IDiyFsServiceApis } from "./IDiyFsServiceApis"
import { store as reduxStore } from "../../reducers/rootReducer"
import ApiUtils from "../ApiUtils"
import { ISearchDiyPacksParams } from "./DiyFsServiceModels"
import { IFetchUpcomingClassesPayload, IFetchUpcomingClassesResponse } from "../../interfaces/api/diyfs/fetchUpcomingClasses"
import { ISubscribeUserPayload, ISubscribeUserResponse } from "../../interfaces/api/diyfs/subscribeUser"

const DiyFsUrl = {
	diyProductCountApi: (appTenant: string) => `/searchData/diyProducts/count?appTenant=${appTenant}`,
	diyFitnessPacksUrl: "/diy/v3/packs?displayStatus=VISIBLE",
	diyFitnessProductUrl: "/diy/v3/getFitnessProducts",
	diyMeditationProductUrl: "/diy/v3/getMeditationProducts",
	diySearchPacks: ({ tenant }: ISearchDiyPacksParams) => `/diy/v3/searchPacks?tenant=${tenant}`,
	fetchUpcomingClasses: "/digitalCatalogue/upcomingClasses",
	subscribeUser: "/digitalCatalogue/subscribeUser" 
}
export default class DiyFsServiceApis implements IDiyFsServiceApis {
	getServiceUrl = (url: string) => `/diy-fs${url}`
	getDiyProductsCount(payload: any): Promise<any> {
		const appTenant = reduxStore.getState()?.accountData?.appTenant?.toLowerCase()
		const url = this.getServiceUrl(DiyFsUrl.diyProductCountApi(appTenant))
		return ApiUtils.post(url, payload)
	}

	getDiyFitnessPacks(): Promise<any> {
		const appTenant = reduxStore.getState()?.accountData?.appTenant?.toLowerCase()
		const url = this.getServiceUrl(
			DiyFsUrl.diySearchPacks({
				tenant: appTenant,
			})
		)
		return ApiUtils.get(url)
	}

	getDiyFitnessProducts(productIds: string[]): Promise<any> {
		return ApiUtils.post(this.getServiceUrl(DiyFsUrl.diyFitnessProductUrl), { productIds })
	}

	getDiyMeditationProducts(productIds: string[]): Promise<any> {
		return ApiUtils.post(this.getServiceUrl(DiyFsUrl.diyMeditationProductUrl), { productIds })
	}

	fetchUpcomingClasses(payload: IFetchUpcomingClassesPayload): Promise<IFetchUpcomingClassesResponse[]> {
		const url = this.getServiceUrl(DiyFsUrl.fetchUpcomingClasses) + "?" + ApiUtils.requestToQueryParams(payload.queryParams);
		delete payload["queryParams"];
		return ApiUtils.post(url, payload);
	}

	subscribeUser (payload: ISubscribeUserPayload): Promise<ISubscribeUserResponse> {
		const url = this.getServiceUrl(DiyFsUrl.subscribeUser)
		return ApiUtils.post(url, payload)
	}
}
